// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var SourceRepository$SF = require("./SourceRepository.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "description",
                Decco.stringToJson(v.description)
              ],
              [
                "tenant",
                Decco.optionToJson(Decco.stringToJson, v.tenant)
              ],
              [
                "connection",
                Decco.optionToJson(Decco.stringToJson, v.connection)
              ],
              [
                "website",
                Decco.optionToJson(Decco.stringToJson, v.website)
              ],
              [
                "options",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.stringToJson, param);
                      }), v.options)
              ],
              [
                "documentation",
                Decco.optionToJson(Decco.stringToJson, v.documentation)
              ],
              [
                "issue-tracker-url",
                Decco.optionToJson(Decco.stringToJson, v.issue_tracker_url)
              ],
              [
                "review-dashboard",
                Decco.optionToJson(Decco.stringToJson, v.review_dashboard)
              ],
              [
                "mailing-lists",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.stringToJson, param);
                      }), v.mailing_lists)
              ],
              [
                "contacts",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.stringToJson, param);
                      }), v.contacts)
              ],
              [
                "source-repositories",
                Curry._1(SourceRepository$SF.codec[0], v.sourceRepositories)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      var tenant = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tenant"), null));
      if (tenant.TAG === /* Ok */0) {
        var connection = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "connection"), null));
        if (connection.TAG === /* Ok */0) {
          var website = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "website"), null));
          if (website.TAG === /* Ok */0) {
            var options = Decco.optionFromJson((function (param) {
                    return Decco.listFromJson(Decco.stringFromJson, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
            if (options.TAG === /* Ok */0) {
              var documentation = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "documentation"), null));
              if (documentation.TAG === /* Ok */0) {
                var issue_tracker_url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issue-tracker-url"), null));
                if (issue_tracker_url.TAG === /* Ok */0) {
                  var review_dashboard = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "review-dashboard"), null));
                  if (review_dashboard.TAG === /* Ok */0) {
                    var mailing_lists = Decco.optionFromJson((function (param) {
                            return Decco.listFromJson(Decco.stringFromJson, param);
                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "mailing-lists"), null));
                    if (mailing_lists.TAG === /* Ok */0) {
                      var contacts = Decco.optionFromJson((function (param) {
                              return Decco.listFromJson(Decco.stringFromJson, param);
                            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "contacts"), null));
                      if (contacts.TAG === /* Ok */0) {
                        var sourceRepositories = Curry._1(SourceRepository$SF.codec[1], Belt_Option.getWithDefault(Js_dict.get(dict$1, "source-repositories"), null));
                        if (sourceRepositories.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    name: name._0,
                                    description: description._0,
                                    tenant: tenant._0,
                                    connection: connection._0,
                                    website: website._0,
                                    options: options._0,
                                    documentation: documentation._0,
                                    issue_tracker_url: issue_tracker_url._0,
                                    review_dashboard: review_dashboard._0,
                                    mailing_lists: mailing_lists._0,
                                    contacts: contacts._0,
                                    sourceRepositories: sourceRepositories._0
                                  }
                                };
                        }
                        var e = sourceRepositories._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".source-repositories" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = contacts._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".contacts" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = mailing_lists._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".mailing-lists" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = review_dashboard._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".review-dashboard" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = issue_tracker_url._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".issue-tracker-url" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = documentation._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".documentation" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = options._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".options" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = website._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".website" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = connection._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".connection" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = tenant._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".tenant" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

function optionEq(x, y) {
  return Belt_Option.eq(x, Caml_option.some(y), Caml_obj.caml_equal);
}

function filterProjectsByTenant(tenant, projects) {
  return Belt_List.keep(projects, (function (project) {
                return optionEq(project.tenant, tenant);
              }));
}

var decode = t_decode;

var encode = t_encode;

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.decode = decode;
exports.encode = encode;
exports.optionEq = optionEq;
exports.filterProjectsByTenant = filterProjectsByTenant;
/* No side effect */
